// extracted by mini-css-extract-plugin
export var orderDetails = "_qx-2";
export var orderImage = "_qx-1";
export var orderMeta = "_qx-3";
export var orderSummary = "_qx-0";
export var rightArrow = "_qx-4";